<script>
export default {
    name: "VMenuItem",
    functional: true,
}
</script>

<template functional>
    <v-list-item v-bind="data.attrs" v-on="listeners" :class="[data.class, data.staticClass]">
        <v-list-item-title>
            <slot></slot>
        </v-list-item-title>
    </v-list-item>
</template>

<style scoped lang="scss">
.v-list-item {
    min-height: 38px;
}
</style>
